import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  type: 'movie',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.CHANGE_TYPE_MOVIE: {
      return {
        ...state,
        type: 'movie',
      };
    }

    case actionsTypes.CHANGE_TYPE_TV: {
      return {
        ...state,
        type: 'tv',
      };
    }

    default:
      return state;
  }
};

export default reducer;
